import { atom } from 'recoil';
import { effectConsoleLogAtomUpdates } from '../helpers/debug';
import type { AuthDetails } from 'tsconfig/types.d';

//Atom
//----------------------------------------------------------------------
// This atom holds the authentication details for the application.
export const authAtom = atom<AuthDetails>({
  key: 'authAtom',
  default: {
    isInitialised: false,
    publicCsrf: '',
  },
  effects: [effectConsoleLogAtomUpdates],
});
